import { render } from "./MinusIcon.vue?vue&type=template&id=583ab384&scoped=true"
import script from "./MinusIcon.vue?vue&type=script&lang=js"
export * from "./MinusIcon.vue?vue&type=script&lang=js"

import "./MinusIcon.vue?vue&type=style&index=0&id=583ab384&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583ab384"]])

export default __exports__